import { withQuestionnaireFuncs } from 'Context/WithQuestionnaireAnswer';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ExpandingTextareaInput from 'Components/UI/BehavioralFormElement/Text/ExpandingTextarea';
import { noop } from 'Helpers/PropTypes';
import { withHousehold } from 'Context/HouseholdContext';
import { ContextIndex } from './FieldList';
import { makeHideable } from '../Hideable';

import './index.css';
import withViewContext from './withViewContext';

class Text extends Component {
  constructor(props) {
    super(props);

    const {
      apiResponse: {
        attributes: { value },
      },
    } = props;

    this.state = {
      value,
      isDone: false,
    };

    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  componentDidMount() {
    const {
      householdId,
      answerKey,
      getQuestionnaireAnswer,
      getIndexedQuestionnaireAnswer,
    } = this.props;
    const index = this.context;

    let promise;
    if (index > -1) {
      promise = getIndexedQuestionnaireAnswer(householdId, answerKey, index);
    } else {
      promise = getQuestionnaireAnswer(householdId, answerKey);
    }

    return promise
      .then((res) => {
        this.setState({ value: res.attributes.value }, () => {
          const {
            props: { name, onChange },
          } = this;
          onChange(name, res.attributes.value);
        });
      })
      .finally(() => this.setState({ isDone: true }));
  }

  onChange(value) {
    const { name, onChange } = this.props;
    this.setState({ value }, onChange(name, value));
  }

  onBlur() {
    const { householdId, uploadValue, answerKey } = this.props;
    const { value } = this.state;
    const index = this.context;
    uploadValue(householdId, answerKey, {
      attributes: {
        value,
        index,
      },
    });
  }

  onKeyDown(e) {
    const { onKeyDown } = this.props;
    onKeyDown(e);
  }

  render() {
    const {
      name, placeholder, minRows, answerKey,
      // We have a prop 'apiResponse' that we need but should not be passed along.
      apiResponse,
      // We get a number of props from 'withHousehold' that should not be passed along.
      householdId,
      uploadValue,
      updateHousehold,
      refreshHousehold,
      folderId,
      primaryClientFirstName,
      primaryClientLastName,
      // Pass the rest of our props along.
      ...rest
    } = this.props;
    const { value, isDone } = this.state;

    if (!isDone) {
      return null;
    }

    return (
      <div className="questionnaire-input">
        <ExpandingTextareaInput
          {...rest}
          value={value}
          test={answerKey}
          label={placeholder}
          minRows={minRows}
          onBlur={e => this.onBlur(e)}
          onChange={(n, v) => {
            this.onChange(v);
          }}
          name={name}
          placeholder={placeholder}
        />
      </div>
    );
  }
}

Text.propTypes = {
  name: PropTypes.string.isRequired,
  uploadValue: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  answerKey: PropTypes.string.isRequired,
  householdId: PropTypes.number.isRequired,
  apiResponse: PropTypes.instanceOf(Object),
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  minRows: PropTypes.number,
  getQuestionnaireAnswer: PropTypes.func.isRequired,
  getIndexedQuestionnaireAnswer: PropTypes.func.isRequired,
};

Text.defaultProps = {
  onChange: noop,
  onKeyDown: noop,
  minRows: 1,
  placeholder: '',
  apiResponse: { attributes: {} },
};

Text.contextType = ContextIndex;

const TextInput = withHousehold(withQuestionnaireFuncs(withViewContext(Text)));

export default makeHideable(TextInput);
